import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuditGuard, AuthGuard } from './auth/auth.guard';
import { IntradayDeliveryComponent } from './layout/intraday-delivery/intraday-delivery.component';
import { NoAuthGuard } from './auth/no-auth.guard';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'login' },
  {
    path: 'login',
    loadChildren: './authentication/authentication.module#AuthenticationModule',
    canActivate : [NoAuthGuard]
    
  },
  { 
    path: 'research',
    loadChildren: './layout/layout.module#LayoutModule',
    canActivate: [AuthGuard]
  },
  { 
    path: 'research-audit',
    loadChildren: './research-audit/research-audit.module#ResearchAuditModule',
    canActivate: [AuditGuard]
  },
  
 
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
